<template>
    <div class="footer-social-media-box link-list link-list__social-media" v-bind="cmsEditHelperAttrs">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <ul class="u-reset link-list--list">
            <li v-for="(entry, index) in content.links"
                    class="link-list--item">
                <a :href="entry.link" target="_blank"
                        rel="noopener noreferrer"
                        :title="entry.title || entry.label"
                        class="u-reset link-list--link">
                    <cmp-icon :symbol="'sm_' + entry.icon" size="small" class="link-list--icon"></cmp-icon>
                    <span class="link-list--text" v-text="entry.label"></span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?1e5268f4